import { type FC, useRef } from 'react'
import { Form } from 'react-bootstrap'
import { ariaDescribedByIds, type WidgetProps } from '@rjsf/utils'
import { useAutoGrowTextarea } from '../../../../../common/useAutoGrowTextarea'
import styles from './TextareaWidget.module.scss'

const ROWS = 3
const MAX_ROWS = 8

export const TextareaWidget: FC<WidgetProps> = ({ id, value, options, placeholder, required, disabled, readonly, rawErrors, onChange, onBlur, onFocus }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  useAutoGrowTextarea(textareaRef, value, { maxRows: MAX_ROWS })

  return (
    <Form.Control
      ref={textareaRef}
      as='textarea'
      id={id}
      name={id}
      className={styles.textarea}
      rows={ROWS}
      value={typeof value === 'string' ? value : ''}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      readOnly={readonly}
      isInvalid={Boolean(rawErrors?.length)}
      aria-describedby={ariaDescribedByIds(id)}
      onChange={(event) => onChange(event.target.value === '' ? options.emptyValue : event.target.value)}
      onBlur={(event) => onBlur(id, event.target.value)}
      onFocus={(event) => onFocus(id, event.target.value)}
    />
  )
}
